export const formatReg = (reg: string | undefined) => {
  if (!reg) return
  const regArr = reg.replace(' ', '').split('')
  if (reg.match(/[A-Z]{3}[0-9]{4}/)) {
    regArr.splice(-4, 0, ' ')
  } else {
    regArr.splice(-3, 0, ' ')
  }
  return regArr.join('')
}
